import watchUtils = require("esri/core/watchUtils");
import GroupLayer = require("esri/layers/GroupLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import * as layerSource from "./layerSource";
import { SimpleRenderer } from 'esri/renderers';
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import FeatureLayer = require('esri/layers/FeatureLayer');
import BuildPopups from "./buildPopups";
import Content = require('esri/popup/content/Content');
import PopupTemplate = require("esri/PopupTemplate");
import FieldsContent = require("esri/popup/content/FieldsContent");
import CustomContent = require("esri/popup/content/CustomContent");
import TextContent = require("esri/popup/content/TextContent");
import AttachmentsContent = require("esri/popup/content/AttachmentsContent");

const vanPicsRoadsRenderer = new SimpleRenderer({
  symbol: new SimpleLineSymbol({
    width: "4px",
    color: [0, 169, 230],
  })
});

const roadwayPlansRenderer = new SimpleRenderer({
  symbol: new SimpleLineSymbol({
    width: "4px",
    color: [210, 145, 255],
  })
});

export const vanPicsRoadsLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.VanPicsRoadLayer,
  renderer: vanPicsRoadsRenderer,
  visible: false, // only turn on when van pics tool is in use.
  opacity: 0.25,
  minScale: 500000,
  title: "Van Pics Roads"
});

export const vanPicsIDOTRoadsLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.VanPicsIDOTRoadLayer,
  renderer: vanPicsRoadsRenderer,
  visible: false, // only turn on when van pics tool is in use.
  opacity: 0.25,
  minScale: 500000,
  title: "IDOT Van Pics Roads"
});

export const airportsLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.AirportsLayer
    }
  ]
});

export const mahometAquiferLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.MahometAquiferLayer
    }
  ]
});

export const restAreasLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  sublayers: [
    {
      id: layerSource.RestAreasLayer
    }
  ]
});

const popupContent:Content[] = [
  new FieldsContent({
      fieldInfos: [
          {
            fieldName: "NAT_NBR",
            label: "Crossing Number"
          },
          {
            fieldName: "INVENTORY"
          },
          {
            fieldName: "ROAD_NAME",
          }
        ]
      }),
  new AttachmentsContent({
      displayType: "list"
  })
  ];

export const rrxLayerPopupTemplate = new PopupTemplate({
  // autocasts as new PopupTemplate()
  title: "RRX Crossing Data",
  content: popupContent
});

const roadwayPlansLayerPopupTemplate = new PopupTemplate({
  title: "Roadway Plans: {Key_Route}",
  content: [
    // A. Structural Attribute Fields Table
    new FieldsContent({ 
      fieldInfos: [
        { fieldName: "Key_Route", label: "Key Route" },
        { fieldName: "DISTRICT", label: "District" },
        { fieldName: "Constructi", label: "Construction Type" },
        { fieldName: "Year", label: "Construction Year" },
        { fieldName: "Section_", label: "Construction Section" },
        { fieldName: "Contract_", label: "Contract Number" },
        { fieldName: "Letting_Da", label: "Let Date" },
        { fieldName: "Letting_It", label: "Let Item" },
        { fieldName: "Jurisdicti", label: "Jurisdiction" },
        { fieldName: "FilePath", label: "File Path" }
      ] 
    }),
    new TextContent({ 
      text: "To copy the <b>Network Plan location</b> click the button below." 
    }),
    
  ],
  // Add the native button here
  actions: [{
    type: "button", 
    title: "Copy Path",
    id: "copy-asset-id",
    className: "esri-icon-share2",
  }]
   
});

export const roadwayPlansLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.RoadwayPlansLayer,
  renderer: roadwayPlansRenderer,
  visible: false,
  minScale: 500000,
  popupEnabled: true,
  popupTemplate: roadwayPlansLayerPopupTemplate,
  title: "Roadway Plans",
  outFields: ["Key_Route", "DISTRICT", "Constructi", "Year", "Section_", "Contract_", "Letting_Da", "Letting_It", "Jurisdicti", "FilePath"] 
});

const plansPopupTemplate = new PopupTemplate({
  title: "Structure Plans: {Structure}",
  content: [
    // A. Structural Attribute Fields Table
    new FieldsContent({ 
      fieldInfos: [
        { fieldName: "Structure" },
        { fieldName: "Contract" },
        { fieldName: "FilePath", label: "File Path" }
      ] 
    }),
    new TextContent({ 
      text: "To copy the <b>Network Plan location</b> click the button below." 
    }),
    
  ],
  // Add the native button here
  actions: [{
    type: "button", 
    title: "Copy Path",
    id: "copy-asset-id",
    className: "esri-icon-share2",
  }]
   
});

export const structurePlansLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  popupTemplate: plansPopupTemplate,
  layerId: layerSource.StructurePlansLayer,
  visible: false,
  popupEnabled: true,
  title: "Structure Plans",
  
  // Mandatory: Tells the server to download this string payload data to client memory
  outFields: ["Structure", "Contract", "FilePath"] 
});

export const rrxCrossingsLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.RRXCrossingLayer,
  popupEnabled: true,
  popupTemplate: rrxLayerPopupTemplate,
  visible: false,
  title: "Railroad Crossings"
});
export const otherLayersGroupLayer = new GroupLayer({
  title: "Other Layers",
  id: "12 - Other Layers",
  visible: true,
  visibilityMode: "independent",
  layers: [mahometAquiferLayer, airportsLayer, vanPicsRoadsLayer, vanPicsIDOTRoadsLayer, restAreasLayer, rrxCrossingsLayer, roadwayPlansLayer, structurePlansLayer]
});

otherLayersGroupLayer.layers.forEach(layer => {
  watchUtils.whenTrueOnce(layer, "loaded", () => {
    if (layer instanceof MapImageLayer) {
      layer.loadAll().then(() => {
        if (layer.sublayers.length === 1) {
          layer.title = layer.sublayers.getItemAt(0).sourceJSON.name;
          layer.sublayers.getItemAt(0).title = layer.sublayers.getItemAt(0).sourceJSON.name;
        }
        BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
      });
    }
  });
});
